import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { replaceNewLinesWithBr } from '../utils/sanity';
import { GatsbySanityImageFluid } from '../types';
import Img from 'gatsby-image/withIEPolyfill';

import * as styles from './CareersSection.module.scss';

interface QueryData {
  sanityContactUsPage: {
    careersSection: {
      title: string;
      text: string;
      image: {
        asset: {
          fluid: GatsbySanityImageFluid;
        };
      };
    };
  };
}

interface CareersSectionProps {
  className?: string;
}

const CareersSection = ({ className }: CareersSectionProps): React.ReactElement => {
  const { t } = useTranslation();
  const data: QueryData = useStaticQuery(
    graphql`
      {
        sanityContactUsPage {
          careersSection {
            title
            text
            image {
              asset {
                fluid(maxWidth: 1920) {
                  ...GatsbySanityImageFluid
                }
              }
            }
          }
        }
      }
    `,
  );

  const careersSection = data.sanityContactUsPage.careersSection;

  return (
    <section className={styles.section}>
      <div className={styles.contentContainer}>
        <div className={styles.content}>
          <h2 className={styles.title}>{careersSection.title}</h2>
          <p className={styles.text}>{replaceNewLinesWithBr(careersSection.text)}</p>
          <Link className={styles.button} to="/careers" target="_blank" rel="noopener noreferrer">
            {t('contact_us_page.careers_section.apply_button', 'Apply now')}
          </Link>
        </div>
        <div className={styles.imageContainer}>
          <Img className={styles.image} fluid={careersSection.image.asset.fluid} alt="" />
        </div>
      </div>
    </section>
  );
};

export default CareersSection;
